/* unplugin-vue-components disabled */import script from "./SideBarContent.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarContent.vue?vue&type=script&setup=true&lang=js"

import "./SideBarContent.vue?vue&type=style&index=0&id=13c3a44a&lang=scss"

const __exports__ = script;

export default __exports__